
import { AddModeratorOutlined, AssessmentOutlined, BadgeOutlined, CampaignOutlined, PublishedWithChangesOutlined, Search } from '@mui/icons-material';
import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined';
import { AppRoutes } from '../../utils/Constants';
import './Layout.css';

export const sideNavItemIcon = {
    search: <Search />,
    reports: <AssessmentOutlined />,
    protectionPlan: <AddModeratorOutlined />,
    transferAccount: <PublishedWithChangesOutlined />,
    userInfo: <BadgeOutlined />,
    campaignSetup: <CampaignOutlined />,
    manageRetailers: <AddBusinessOutlinedIcon />,

}

export const sideNavItems = [
    {
        id: 'panel1',
        title: 'Search',
        titleIcon: 'search',
        titleRoute: '',
        nestedItems: [
            {
                subRouteId: 'search-sub-panel1',
                subRoute: AppRoutes.registrationSearch,
                subRouteTitle: 'Registration Search',
                role: {
                    SPR_AdminUser: true,
                    SPR_CS_SuperUser: true,
                    SPR_CS_Agent: true,
                    SPR_BusinessUser: true,
                    SPR_SalesAndMarketingUser: false,
                },
            },
            {
                subRouteId: 'search-sub-panel2',
                subRoute: AppRoutes.entitlementSearch,
                subRouteTitle: 'Entitlement Search',
                role: {
                    SPR_AdminUser: true,
                    SPR_CS_SuperUser: true,
                    SPR_CS_Agent: false,
                    SPR_BusinessUser: false,
                    SPR_SalesAndMarketingUser: false,
                }
            },
            {
                subRouteId: 'search-sub-panel3',
                subRoute: AppRoutes.userInfoSearch,
                subRouteTitle: 'User Info Search',
                role: {
                    SPR_AdminUser: true,
                    SPR_CS_SuperUser: true,
                    SPR_CS_Agent: false,
                    SPR_BusinessUser: false,
                    SPR_SalesAndMarketingUser: false,
                }
            },
            {
                subRouteId: 'search-detail-sub-panel3',
                hidden: true,
                subRoute: AppRoutes.searchDetails,
                subRouteTitle: 'Search Detail',
                role: {
                    SPR_AdminUser: true,
                    SPR_CS_SuperUser: true,
                    SPR_CS_Agent: true,
                    SPR_BusinessUser: true,
                    SPR_SalesAndMarketingUser: false,
                }
            }
        ],
        role: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: true,
            SPR_BusinessUser: true,
            SPR_SalesAndMarketingUser: false,
        }
    },
    {
        id: 'panel2',
        title: 'Reports',
        titleRoute: '',
        titleIcon: 'reports',
        nestedItems: [
            {
                subRouteId: 'reports-sub-panel1',
                subRoute: AppRoutes.view_reports,
                subRouteTitle: 'View Reports',
                role: {
                    SPR_AdminUser: true,
                    SPR_CS_SuperUser: true,
                    SPR_CS_Agent: false,
                    SPR_BusinessUser: true,
                    SPR_SalesAndMarketingUser: true,
                }
            },
            {
                subRouteId: 'reports-sub-panel2',
                subRoute: AppRoutes.generateBulkReport,
                subRouteTitle: 'Generate Bulk Reports',
                role: {
                    SPR_AdminUser: true,
                    SPR_CS_SuperUser: true,
                    SPR_CS_Agent: false,
                    SPR_BusinessUser: true,
                    SPR_SalesAndMarketingUser: false,
                }
            },
            {
                subRouteId: 'reports-sub-panel3',
                subRoute: AppRoutes.viewBulkReport,
                subRouteTitle: 'View Bulk Reports',
                role: {
                    SPR_AdminUser: true,
                    SPR_CS_SuperUser: true,
                    SPR_CS_Agent: false,
                    SPR_BusinessUser: true,
                    SPR_SalesAndMarketingUser: false,
                }
            },
        ],
        role: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: true,
            SPR_SalesAndMarketingUser: true,
        }
    },
    {
        id: 'panel3',
        title: 'Protection Plan',
        titleRoute: '',
        titleIcon: 'protectionPlan',
        nestedItems: [
            {
                subRouteId: 'protection-plan-sub-panel1',
                subRoute: AppRoutes.updateProtectionPlan,
                subRouteTitle: 'Update Protection Plan SKU',
                role: {
                    SPR_AdminUser: true,
                    SPR_CS_SuperUser: true,
                    SPR_CS_Agent: true,
                    SPR_BusinessUser: false,
                    SPR_SalesAndMarketingUser: false,
                }
            },
        ],
        role: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: true,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        }
    },
    {
        id: 'panel4',
        title: 'Campaign',
        titleRoute: '',
        titleIcon: 'campaignSetup',
        nestedItems: [
            {
                subRouteId: 'campaign-setup-sub-panel1',
                subRoute: AppRoutes.campaignSetup,
                subRouteTitle: 'Default Campaign Setup',
                role: {
                    SPR_AdminUser: true,
                    SPR_CS_SuperUser: true,
                    SPR_CS_Agent: false,
                    SPR_BusinessUser: true,
                    SPR_SalesAndMarketingUser: false,
                }
            },
        ],
        role: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: true,
            SPR_SalesAndMarketingUser: false,
        }
    },
    {
        id: 'panel5',
        title: 'Transfer of Account',
        titleRoute: AppRoutes.transferAccount,
        titleIcon: 'transferAccount',
        nestedItems: [],
        role: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        }
    },
    {
        id: 'panel6',
        title: 'Manage Retailer',
        titleRoute: AppRoutes.manageRetailers,
        titleIcon: 'manageRetailers',
        nestedItems: [],
        role: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: false,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        }
    },
]